import Prose from '../prose';

import type { FunctionComponent } from 'react';
import type { TypeContent01Props } from './types';

/**
 * Content01
 */
export const Content01: FunctionComponent<TypeContent01Props> = ({
  className = '',
  pretitle,
  title,
  subtitle,
  children,
  isDark,
}: TypeContent01Props) => (
  <div
    className={`flex flex-col gap-5 ${isDark ? 'text-white' : ''} ${className}`}
  >
    {pretitle && (
      <span className="u-actions u-actions--nav font-semibold italic text-secondary-500">
        {pretitle}
      </span>
    )}

    {title && <h3 className="u-display u-display--s">{title}</h3>}

    {subtitle && (
      <span className="u-actions u-actions--nav font-semibold italic text-secondary-500">
        {subtitle}
      </span>
    )}

    {children && (
      <Prose
        className="u-body u-body--m text-typo-primary md:u-body--l marker:text-typo-primary prose-strong:font-black prose-strong:text-inherit"
        html={children as string}
      />
    )}
  </div>
);
